<template>
    <page>
        <data-list
            ref="list"
            :plural="$T(plural)"
            :singular="$T(singular)"
            :slug="slug"
            :icon="icon"
            :columns="translatedColumns"
            :row-click="showDetail"
            :export-route="exportRoute"
            :direct-export-route="directExportRoute"
            :reverse-flow="reverseFlowRoute"
            :create-route="createRoute"
            :tab-filters="translatedTabFilters"
            @openModalDetail="openModalDetail($event)"
        />
        <component
            :is="detailComp"
            :item="item"
            :show="modalDetail"
            :label="collapsibleLabel"
            :subLabel="collapsibleSubLabel"
            @close="modalDetail=false"
            @updated="refreshList"
        />
    </page>
</template>

<script>
    import dataList from './_list'
    import orderColumns from './orderColumns'
    import stockColumns from './stockColumns'
    import lendingKitColumns from './lendingKitColumns'
    import orderDetail from './_orderDetail'
    import lendingKitDetail from './_lendingKitDetail'
    import lendingKitPendingReceptionColumns from "./lendingKitPendingReceptionColumns"
    import lendingKitPendingReceptionDetail from './_lendingKitPendingReceptionDetail'
    import orderInLendingColumns from "./orderInLendingColumns"
    import orderColumnsMobile from "./orderColumnsMobile"
    import lendingKitColumnsMobile from "./lendingKitColumnsMobile"
    import stockColumnsMobile from "./stockColumnsMobile"
    import lendingKitPendingReceptionColumnsMobile from "./lendingKitPendingReceptionColumnsMobile"
    import orderInLendingColumnsMobile from "./orderInLendingColumnsMobile"

    export default {
        middleware: 'auth',

        mixins: [
            orderColumns,
            lendingKitColumns,
            stockColumns,
            lendingKitPendingReceptionColumns,
            orderInLendingColumns,
            orderColumnsMobile,
            lendingKitColumnsMobile,
            stockColumnsMobile,
            lendingKitPendingReceptionColumnsMobile,
            orderInLendingColumnsMobile
        ],

        components: {
            dataList,
            orderDetail,
            lendingKitDetail,
            lendingKitPendingReceptionDetail
        },

        props: {
            slug: String,
            singular: String,
            plural: String,
            icon: String,
            columnsDef: String,
            tabFilterDef: String,
            detailComp: String,
            createRoute: String,
            exportRoute: String,
            directExportRoute: String,
            reverseFlowRoute: String,
            mobileColumnsDef: String
        },

        data() {
            return {
                modalDetail: false,
                item: {},
                columnsCollapsible: [],
                collapsibleLabel: '',
                collapsibleSubLabel: ''
            }
        },

        methods: {
            showDetail(item) {
                this.item = item
                this.modalDetail = true
            },

            refreshList() {
                this.$refs.list.refreshRows()
            },

            openModalDetail(obj){
                this.showDetail(obj.contentItem)
                this.$nextTick(() => {
                    this.columnsCollapsible = obj.columnsCollapsible
                })
            }
        },

        computed: {
            translatedColumns() {
                let columnsDefault = this.$q.platform.is.mobile && this.mobileColumnsDef ? this.mobileColumnsDef : this.columnsDef
                return this[columnsDefault].map(column => {
                    return {
                        name: column.field,
                        label: this.$T(column.label),
                        field: column.field,
                        align: column.align || 'left',
                        sortable: column.sortable || false,
                        required: column.required || false,
                        collapsibleLabel: column.hasOwnProperty('collapsibleLabel') && column.collapsibleLabel ? column.field : '',
                        collapsibleSubLabel: column.hasOwnProperty('collapsibleSubLabel') && column.collapsibleSubLabel ? column.field : '',
                        type:  column.hasOwnProperty('type') && column.type ? column.type : ''
                    }
                })
            },

            translatedTabFilters () {
                return this[this.tabFilterDef]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/list.vue